import { useWalletModal } from '@solana/wallet-adapter-ant-design';
import { useWallet } from '@solana/wallet-adapter-react';
import { Col, Drawer, Row } from 'antd';
import { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useStack } from '../../hooks/useStaking';
import { Button } from '../Button';
import {
  Burger,
  CustomNavLinkSmall,
  HeaderSection,
  Label,
  LogoContainer,
  Menu,
  NavbarLinkRoot,
  NotHidden,
  Outline,
  RefreshBtn,
  Span,
  WalletInfoText,
} from './styles';

const Header = ({ t }: any) => {
  const [visible, setVisibility] = useState(false);

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const location = useLocation();
    const { setVisible: setOpenWalletModal } = useWalletModal();
    const { disconnect, connected, publicKey } = useWallet();
    const { refreshAnimals } = useStack();
    // const scrollTo = (id: string) => {
    //   const element = document.getElementById(id) as HTMLDivElement;
    //   element.scrollIntoView({
    //     behavior: "smooth",
    //   });
    //   setVisibility(false);
    // };

    return (
      <NavbarLinkRoot>
        <CustomNavLinkSmall
          onClick={() =>
            window.open('https://magiceden.io/marketplace/malibu_dolphin_mixer')
          }
        >
          <Span>{t('Buy')}</Span>
        </CustomNavLinkSmall>
        {location.pathname !== '/staking' && (
          <CustomNavLinkSmall style={{ width: '100px' }}>
            <Link to='/staking'>
              <Button>
                <span className='withBox'> {t('Stake')} </span>
              </Button>
            </Link>
          </CustomNavLinkSmall>
        )}
        <CustomNavLinkSmall style={{ width: '180px' }}>
          <Link to='/mint'>
            <Button>
              <span className='withBox'>Mint Elementals</span>
            </Button>
          </Link>
        </CustomNavLinkSmall>

        {location.pathname === '/staking' && connected && (
          <RefreshBtn onClick={() => refreshAnimals()}>Refresh</RefreshBtn>
        )}
        {connected ? (
          <>
            <button onClick={() => disconnect()}>Disconnect</button>
            <WalletInfoText>
              <svg
                id='Layer_1'
                data-name='Layer 1'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 25 25'
              >
                <title>Wallet</title>
                <path
                  id='Wallet'
                  d='M20,15a1,1,0,1,1-1-1A1,1,0,0,1,20,15Zm5-1.75v3.5A1.23,1.23,0,0,1,24,18v3.8A1.25,1.25,0,0,1,22.75,23H2.5A2.5,2.5,0,0,1,0,20.5V5.5A2.5,2.5,0,0,1,2.5,3H20.75A1.25,1.25,0,0,1,22,4.25V7h.75A1.25,1.25,0,0,1,24,8.25v3.8A1.23,1.23,0,0,1,25,13.25ZM1,5.5a1.46,1.46,0,0,0,.46,1.08A1.49,1.49,0,0,0,2.5,7H21V6H3V5H21V4.25A.25.25,0,0,0,20.75,4H2.5A1.5,1.5,0,0,0,1,5.5ZM23,18H19a3,3,0,1,1,0-6h4V8.25A.25.25,0,0,0,22.75,8H2.5A2.47,2.47,0,0,1,1,7.48v13A1.5,1.5,0,0,0,2.5,22H22.75a.25.25,0,0,0,.25-.25Zm1-4.75a.25.25,0,0,0-.25-.25H19a2,2,0,0,0-2,2.34A2.08,2.08,0,0,0,19.11,17h4.64a.25.25,0,0,0,.25-.25Z'
                />
              </svg>{' '}
              {publicKey?.toString().substring(0, 4)}...
              {publicKey
                ?.toString()
                .substring(
                  publicKey?.toString().length - 2,
                  publicKey?.toString().length
                )}
            </WalletInfoText>
          </>
        ) : (
          <button onClick={() => setOpenWalletModal(true)}>Connect</button>
        )}
      </NavbarLinkRoot>
    );
  };

  return (
    <HeaderSection>
      <Row justify='space-between'>
        <LogoContainer to='/' aria-label='homepage'>
          <img src='high_res_logo_bw.png' width='64px' height='64px' />
          {/* <SvgIcon src='logo.svg' width='101px' height='64px' /> */}
        </LogoContainer>
        <NotHidden>
          <MenuItem />
        </NotHidden>
        <Burger onClick={showDrawer}>
          <Outline />
        </Burger>
      </Row>
      <Drawer closable={false} visible={visible} onClose={onClose}>
        <Col style={{ marginBottom: '2.5rem' }}>
          <Label onClick={onClose}>
            <Col span={12}>
              <Menu>Menu</Menu>
            </Col>
            <Col span={12}>
              <Outline />
            </Col>
          </Label>
        </Col>
        <MenuItem />
      </Drawer>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
